/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgExa = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 2h15.82c0 .465.001.93-.005 1.396a.307.307 0 0 1-.062.175 8033.149 8033.149 0 0 1-6.627 8.346c-.05.063-.05.103 0 .166 2.21 2.78 4.42 5.563 6.627 8.347a.308.308 0 0 1 .062.174c.006.465.004.93.005 1.396H4c.002-.038.007-.077.007-.116V2.116c0-.038-.005-.077-.007-.116zm8.017 8.641 5.509-7.154H6.507l5.51 7.154zm0 2.718-5.509 7.153h11.017l-5.508-7.153zM5.8 5.286l-.024.01c-.002.026-.006.051-.006.076 0 1.93 0 3.86-.002 5.79 0 .08.023.104.105.104 1.47-.002 2.941-.002 4.412-.002.03 0 .06-.005.11-.01L5.801 5.287zm-.03 13.416.03.012 4.602-5.979H5.896c-.083 0-.125.044-.125.13v5.73z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgExa as Exa };
